export enum TypeOfCutEnum {
  OneToFour = '1-4',
  OneToFive = '1-5',
  TwoToFour = '2-4',
  TwoToFive = '2-5'
}